/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowActivity200ResponseDataCar } from './ShowActivity200ResponseDataCar';
import {
    ShowActivity200ResponseDataCarFromJSON,
    ShowActivity200ResponseDataCarFromJSONTyped,
    ShowActivity200ResponseDataCarToJSON,
    ShowActivity200ResponseDataCarToJSONTyped,
} from './ShowActivity200ResponseDataCar';
import type { ShowActivity200ResponseDataUser } from './ShowActivity200ResponseDataUser';
import {
    ShowActivity200ResponseDataUserFromJSON,
    ShowActivity200ResponseDataUserFromJSONTyped,
    ShowActivity200ResponseDataUserToJSON,
    ShowActivity200ResponseDataUserToJSONTyped,
} from './ShowActivity200ResponseDataUser';

/**
 * 
 * @export
 * @interface ShowActivity200ResponseData
 */
export interface ShowActivity200ResponseData {
    /**
     * 
     * @type {number}
     * @memberof ShowActivity200ResponseData
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowActivity200ResponseData
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowActivity200ResponseData
     */
    carId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseData
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseData
     */
    typeLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseData
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseData
     */
    locationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseData
     */
    lat?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseData
     */
    lng?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseData
     */
    scheduledAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowActivity200ResponseData
     */
    isPublic?: boolean;
    /**
     * 
     * @type {ShowActivity200ResponseDataUser}
     * @memberof ShowActivity200ResponseData
     */
    user?: ShowActivity200ResponseDataUser;
    /**
     * 
     * @type {ShowActivity200ResponseDataCar}
     * @memberof ShowActivity200ResponseData
     */
    car?: ShowActivity200ResponseDataCar;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseData
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseData
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ShowActivity200ResponseData interface.
 */
export function instanceOfShowActivity200ResponseData(value: object): value is ShowActivity200ResponseData {
    return true;
}

export function ShowActivity200ResponseDataFromJSON(json: any): ShowActivity200ResponseData {
    return ShowActivity200ResponseDataFromJSONTyped(json, false);
}

export function ShowActivity200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowActivity200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'carId': json['car_id'] == null ? undefined : json['car_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'typeLabel': json['type_label'] == null ? undefined : json['type_label'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'locationName': json['location_name'] == null ? undefined : json['location_name'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'scheduledAt': json['scheduled_at'] == null ? undefined : json['scheduled_at'],
        'isPublic': json['is_public'] == null ? undefined : json['is_public'],
        'user': json['user'] == null ? undefined : ShowActivity200ResponseDataUserFromJSON(json['user']),
        'car': json['car'] == null ? undefined : ShowActivity200ResponseDataCarFromJSON(json['car']),
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ShowActivity200ResponseDataToJSON(json: any): ShowActivity200ResponseData {
    return ShowActivity200ResponseDataToJSONTyped(json, false);
}

export function ShowActivity200ResponseDataToJSONTyped(value?: ShowActivity200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['userId'],
        'car_id': value['carId'],
        'type': value['type'],
        'type_label': value['typeLabel'],
        'summary': value['summary'],
        'location_name': value['locationName'],
        'lat': value['lat'],
        'lng': value['lng'],
        'scheduled_at': value['scheduledAt'],
        'is_public': value['isPublic'],
        'user': ShowActivity200ResponseDataUserToJSON(value['user']),
        'car': ShowActivity200ResponseDataCarToJSON(value['car']),
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

